import { FleekError } from './FleekError';

type IpfsGatewayContentUnreachableErrorOptions = {
  url: string;
};

export class IpfsGatewayContentUnreachableError extends FleekError<IpfsGatewayContentUnreachableErrorOptions> {
  public name = 'IpfsGatewayContentUnreachableError';

  toString = () => 'Cannot get IPFS content through Fleek gateway.';
}
